import React from 'react';
import IntroBox from './IntroBox';
import biglogo2 from '../assets/ethereumLogo.png';
import twitterlogo from '../assets/twitterIcon.png';
import githublogo from '../assets/githubIcon.png';

import { Text } from 'rimble-ui';

export default function IntroPage() {
	return (
		<div>
			<IntroBox />
			<div style={{ fontSize: 'x-large' }}>
				<div
					style={{
						left: '10px',
						bottom: '10px',
						position: 'absolute',
						margin: '10px',
						display: 'block',
						marginBottom: '50px'
					}}
				>
					<a
						style={{
							margin: 'auto'
						}}
						target="_blank"
						rel="noopener noreferrer"
						href="https://twitter.com/SendUsdc"
					>
						<img src={twitterlogo} style={{ height: '45px', width: '45px' }} alt="twitter-logo" />
					</a>
					<a
						style={{
							margin: 'auto'
						}}
						target="_blank"
						rel="noopener noreferrer"
						href="https://github.com/sendUSDC/sendUSDC.github.io"
					>
						<img src={githublogo} style={{ height: '45px', width: '45px' }} alt="github-logo" />
					</a>
					<Text>v1.0.0-beta</Text>

					<a
						style={{
							color: 'white',
							display: 'block'
						}}
						target="_blank"
						rel="noopener noreferrer"
						href="https://hack.ethglobal.co/showcase/spell-caster-reczd5XuUZ66ORG26"
					>
						<img src={biglogo2} style={{ height: '22px', width: '13px' }} alt="ETH-logo" /> ETHGlobal
						Hackathon Project{' '}
					</a>
				</div>
			</div>
		</div>
	);
}
